import { IMAGES } from '../Constants';

export const PDFWatermark = {
  add: function (doc) {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = IMAGES.LOGO;

      img.onload = function () {

        const imgWidth = 200; 
        const imgHeight = (img.height * imgWidth) / img.width;
        const centerX = (doc.internal.pageSize.width - imgWidth) / 2;
        const centerY = (doc.internal.pageSize.height - imgHeight) / 2;

        doc.saveGraphicsState();
        const gState = new doc.GState({ opacity: 0.2 }); // Lower opacity for better effect
        doc.setGState(gState);

        doc.addImage(
          img,
          'PNG',
          centerX,
          centerY,
          imgWidth,
          imgHeight
        );

        doc.restoreGraphicsState();
        resolve(); // Ensure the function waits for the image to load
      };

      img.onerror = function () {
        console.error(' Failed to load watermark image:', IMAGES.LOGO);
        resolve();
      };
    });
  }
};
